import { environment } from '../../../environments/environment';

export const FIREBASE_CONFIGURATION = environment.firebase;
